export const siteInfo = {
  name: '琪琪影院',
  tagline: '高清蓝光 · 免费在线看 · 片库持续更新',
  description:
    '琪琪影院致力于为广大电影爱好者打造一站式电影大全在线观看平台。我们汇聚最新电影、热门电影、科幻电影、动作电影等海量资源，全部采用高清蓝光画质，免费看不缓冲，给您影院级的观影体验。每日更新片库，无论是最新上映的大片，还是经典老片，都能在这里找到。',
  stats: [
    { label: '收录影片', value: '28,600+' },
    { label: '每日更新', value: '50+' },
    { label: '蓝光画质', value: '100%' },
  ],
};

export const navItems = [
  { label: '热门话题', href: '#topics' },
  { label: '移动观影', href: '#app' },
  { label: '热播榜单', href: '#ranking' },
  { label: '联系我们', href: '#contact' },
  { label: '观众热评', href: '#comments' },
];

export const topics = [
  { label: '科幻巨制', heat: '9.8万讨论', icon: 'ri-rocket-2-line', active: true },
  { label: '动作猛片', heat: '8.5万讨论', icon: 'ri-flashlight-line', active: false },
  { label: '悬疑烧脑', heat: '7.2万讨论', icon: 'ri-mind-map', active: false },
  { label: '喜剧之王', heat: '6.9万讨论', icon: 'ri-emotion-laugh-line', active: false },
  { label: '恐怖惊悚', heat: '5.6万讨论', icon: 'ri-ghost-line', active: false },
  { label: '动画精选', heat: '5.3万讨论', icon: 'ri-movie-2-line', active: false },
  { label: '纪录片', heat: '4.8万讨论', icon: 'ri-camera-line', active: false },
  { label: '战争史诗', heat: '4.2万讨论', icon: 'ri-shield-flash-line', active: false },
  { label: '爱情文艺', heat: '3.9万讨论', icon: 'ri-heart-line', active: false },
  { label: '犯罪黑帮', heat: '3.5万讨论', icon: 'ri-knife-line', active: false },
  { label: '奇幻冒险', heat: '3.1万讨论', icon: 'ri-compass-3-line', active: false },
];

export const carouselItems = [
  {
    title: '星际穿越：人类最后的远征',
    category: '科幻巨制',
    desc: '诺兰导演科幻神作，穿越虫洞寻找人类新家园，IMAX 蓝光画质震撼呈现时空弯曲的壮丽奇观。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20of%20a%20spaceship%20entering%20a%20wormhole%20with%20swirling%20galactic%20light%20and%20stars%2C%20epic%20science%20fiction%20movie%20aesthetic%2C%20deep%20space%20with%20warm%20golden%20and%20crimson%20nebula%20colors%2C%20dramatic%20cinematography%2C%20immersive%20composition%2C%20dark%20background%20with%20vibrant%20cosmic%20rays&width=800&height=500&seq=carousel-1&orientation=landscape',
  },
  {
    title: '疾速追杀4：终极复仇之路',
    category: '动作猛片',
    desc: '基努·里维斯回归，全球追杀大战升级，枪战与格斗场面全程高能，动作电影年度巅峰之作。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20action%20movie%20scene%20with%20a%20lone%20fighter%20in%20a%20dark%20suit%20standing%20in%20a%20rainy%20neon-lit%20alley%2C%20cinematic%20lighting%20with%20warm%20amber%20and%20deep%20shadows%2C%20dramatic%20composition%2C%20film%20noir%20aesthetic%2C%20high%20contrast&width=800&height=500&seq=carousel-2&orientation=landscape',
  },
  {
    title: '奥本海默：原子弹之父的内心风暴',
    category: '剧情巨制',
    desc: '克里斯托弗·诺兰又一力作，讲述原子弹之父的传奇人生，IMAX 胶片拍摄带来前所未有的沉浸感。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20portrait%20of%20a%20scientist%20silhouetted%20against%20a%20massive%20mushroom%20cloud%20with%20warm%20orange%20and%20golden%20light%2C%20intense%20expression%2C%20epic%20scale%2C%20dark%20moody%20atmosphere%2C%20historical%20drama%20film%20aesthetic&width=800&height=500&seq=carousel-3&orientation=landscape',
  },
  {
    title: '流浪地球3：太阳系终极拯救',
    category: '科幻巨制',
    desc: '中国科幻电影巅峰续作，人类带着地球继续星际流浪，特效全面升级，蓝光画质细节拉满。',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20sci-fi%20scene%20of%20planet%20Earth%20with%20massive%20engines%20propelling%20it%20through%20deep%20space%2C%20surrounded%20by%20stars%20and%20nebula%2C%20cinematic%20wide%20shot%2C%20blue%20engine%20glow%20against%20dark%20cosmic%20background%2C%20epic%20scale&width=800&height=500&seq=carousel-4&orientation=landscape',
  },
  {
    title: '沙丘2：复仇与预言的交织',
    category: '科幻史诗',
    desc: '维伦纽瓦打造科幻史诗新篇章，保罗的复仇之路与沙漠星球的命运交错，视觉盛宴不容错过。',
    image: 'https://readdy.ai/api/search-image?query=A%20vast%20desert%20landscape%20with%20golden%20sand%20dunes%20under%20a%20dramatic%20sky%2C%20a%20lone%20figure%20in%20flowing%20robes%20standing%20on%20a%20ridge%2C%20cinematic%20composition%2C%20warm%20amber%20and%20terracotta%20tones%2C%20epic%20film%20aesthetic&width=800&height=500&seq=carousel-5&orientation=landscape',
  },
  {
    title: '碟中谍8：最终清算',
    category: '动作猛片',
    desc: '汤姆·克鲁斯再度挑战极限，实拍特技全面超越前作，海陆空三栖激战，动作电影新标杆。',
    image: 'https://readdy.ai/api/search-image?query=A%20high-octane%20action%20scene%20of%20a%20motorcycle%20chase%20through%20narrow%20ancient%20city%20streets%2C%20motion%20blur%2C%20warm%20sunlight%20streaming%20through%20buildings%2C%20cinematic%20action%20photography%2C%20intense%20speed%20and%20dynamic%20composition&width=800&height=500&seq=carousel-6&orientation=landscape',
  },
];

export const appEntry = {
  title: '琪琪影院移动端',
  desc: '下载琪琪影院移动客户端，随时随地畅享高清蓝光电影。支持离线缓存、画质切换、投屏播放，地铁通勤、旅途消遣的最佳伴侣。',
  features: ['离线缓存', '画质切换', '投屏播放', '夜间模式'],
};

export const contactEntry = {
  title: '片源投稿与合作',
  desc: '欢迎影视制作方、发行方和版权方与我们联系合作。同时我们也接受热心影迷的片源推荐和纠错反馈，一起打造更全的电影大全。',
  email: 'contact@qicinema.com',
  wechat: 'qicinema_official',
};

export const mediaItems = [
  {
    title: '【蓝光画质对比】4K vs 1080P 到底差多少？',
    cover: 'https://readdy.ai/api/search-image?query=A%20side-by-side%20comparison%20of%20movie%20quality%20showing%20crystal%20clear%204K%20resolution%20versus%20standard%20HD%2C%20detailed%20textures%20visible%2C%20warm%20cinematic%20lighting%2C%20professional%20video%20production%20aesthetic&width=640&height=360&seq=media-1&orientation=landscape',
    duration: '12:38',
    views: '56.8万',
  },
  {
    title: '2026年必看科幻电影Top10盘点',
    cover: 'https://readdy.ai/api/search-image?query=A%20collage%20of%20futuristic%20sci-fi%20movie%20scenes%20with%20spaceships%2C%20robots%2C%20and%20alien%20landscapes%2C%20cinematic%20compilation%20aesthetic%2C%20warm%20and%20cool%20tone%20contrast%2C%20professional%20film%20poster%20style&width=640&height=360&seq=media-2&orientation=landscape',
    duration: '18:25',
    views: '42.3万',
  },
  {
    title: '动作电影幕后特辑：实拍特技有多疯狂',
    cover: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20an%20action%20movie%20with%20stunt%20coordinators%20setting%20up%20a%20car%20chase%2C%20cameras%20and%20rigs%20visible%2C%20warm%20set%20lighting%2C%20professional%20film%20production%20documentary%20style&width=640&height=360&seq=media-3&orientation=landscape',
    duration: '22:10',
    views: '38.1万',
  },
  {
    title: '诺兰电影美学：为什么他的画面如此震撼',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautifully%20composed%20cinematic%20shot%20with%20symmetrical%20architecture%20and%20dramatic%20lighting%2C%20Christopher%20Nolan%20film%20aesthetic%2C%20wide%20angle%20perspective%2C%20warm%20and%20deep%20color%20grading%2C%20professional%20cinematography&width=640&height=360&seq=media-4&orientation=landscape',
    duration: '15:42',
    views: '61.5万',
  },
];

export const faqItems = [
  {
    q: '琪琪影院的电影资源都是免费观看的吗？',
    a: '是的，琪琪影院所有电影资源均提供免费在线观看服务。我们致力于打造最全的电影大全平台，让每一位影迷都能零门槛享受高清蓝光画质的观影体验。',
  },
  {
    q: '播放电影时需要缓冲很久吗？',
    a: '完全不用担心。琪琪影院采用先进的CDN加速和P2P传输技术，配合高性能服务器集群，确保最新电影和热门电影都能流畅播放，即使是蓝光画质也能做到即点即看、不缓冲。',
  },
  {
    q: '支持哪些设备观看？画质如何？',
    a: '琪琪影院全面支持电脑、平板、手机等设备，自适应不同屏幕尺寸。所有电影默认提供高清蓝光画质，同时支持画质手动切换，在网络不佳时可以选择流畅模式。',
  },
  {
    q: '科幻电影和动作电影的片源更新快吗？',
    a: '我们拥有专业的片源团队，科幻电影和动作电影作为平台核心品类，每日保持50+部的更新速度。院线新片下映后最快72小时内即可上线蓝光版本。',
  },
  {
    q: '如何向我们推荐电影或反馈问题？',
    a: '您可以通过页面底部的联系信息或投稿入口向我们发送片源推荐和纠错反馈。我们非常重视每一位影迷的建议，通常24小时内会有专人回复处理。',
  },
];

export const featureItems = [
  {
    icon: 'ri-4k-line',
    title: '真蓝光画质',
    desc: '全站电影采用H.265编码蓝光源，最高支持4K分辨率，每一帧都纤毫毕现，带来影院级视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '全球CDN加速节点覆盖，智能码率自适应，看科幻电影动作电影全程流畅不卡顿。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新50+',
    desc: '专业片源团队全天候更新，最新电影热门电影第一时间上线，片库永远新鲜。',
  },
  {
    icon: 'ri-device-line',
    title: '全设备适配',
    desc: '电脑、平板、手机无缝切换，支持投屏到电视，随时随地畅享电影大全。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '观影过程零干扰，没有弹窗、没有片头广告，专注于电影本身的纯粹体验。',
  },
];

export const aboutContent = {
  title: '关于琪琪影院',
  paragraphs: [
    '琪琪影院创立于2019年，是国内领先的电影大全在线观看平台之一。我们始终秉持"让好电影触手可及"的理念，汇聚全球最新电影、热门电影、科幻电影、动作电影等海量资源，为影迷提供高清蓝光免费在线看服务。',
    '经过多年发展，琪琪影院已收录超过28,600部影片，涵盖科幻、动作、悬疑、喜剧、恐怖、动画、纪录片等全品类，日均服务超过百万影迷。我们坚持每日更新片库，确保您总能在这里找到想看的好电影。',
    '未来，琪琪影院将持续优化观影体验，拓展更多优质片源，努力成为每位影迷心中最信赖的电影大全平台。',
  ],
};

export const indexItems = [
  { title: '2026科幻电影年鉴', desc: '年度科幻巨制全收录', count: '186部', icon: 'ri-rocket-2-line' },
  { title: '动作电影热血合集', desc: '肾上腺素飙升之作', count: '253部', icon: 'ri-flashlight-line' },
  { title: 'IMDB Top250 精选', desc: '全球影迷公认神作', count: '250部', icon: 'ri-star-line' },
  { title: '豆瓣高分华语片', desc: '华语电影的骄傲', count: '178部', icon: 'ri-flag-2-line' },
  { title: '奥斯卡获奖影片', desc: '小金人荣耀殿堂', count: '142部', icon: 'ri-trophy-line' },
  { title: '诺兰导演合集', desc: '从不失手的男人', count: '12部', icon: 'ri-film-line' },
  { title: '漫威宇宙全系列', desc: '按时间线完整梳理', count: '38部', icon: 'ri-shield-star-line' },
  { title: '日韩经典电影库', desc: '东亚电影美学精华', count: '320部', icon: 'ri-sun-line' },
  { title: '恐怖片午夜专场', desc: '胆大者的深夜食堂', count: '215部', icon: 'ri-ghost-smile-line' },
];

export const updateItems = [
  { time: '2026-07-30', title: '星际穿越4K重制版上线', desc: '诺兰经典科幻以4K蓝光画质重新压制，新增IMAX画面比例版本。' },
  { time: '2026-07-29', title: '碟中谍8独家上线', desc: '阿汤哥最新力作，琪琪影院全网首发蓝光版，海陆空三栖激战全程高能。' },
  { time: '2026-07-28', title: '片库突破28,600部', desc: '平台收录影片总量再创新高，科幻电影和动作电影品类新增300+部。' },
  { time: '2026-07-27', title: '播放器全面升级', desc: '新版播放器支持HDR显示和杜比音效，观影体验再上一个台阶。' },
  { time: '2026-07-26', title: '沙丘2 蓝光版上线', desc: '维伦纽瓦科幻史诗续作，4K蓝光画质完美呈现沙漠星球的壮丽景象。' },
  { time: '2026-07-25', title: '暑期档专题上线', desc: '暑期档热门电影一网打尽，科幻动作大片轮番上阵，陪你清凉一夏。' },
  { time: '2026-07-24', title: '移动端缓存功能优化', desc: '离线缓存速度提升40%，支持后台下载，通勤路上也能畅享蓝光电影。' },
  { time: '2026-07-23', title: '流浪地球3 4K版上线', desc: '中国科幻之光第三部，蓝光超高清画质震撼呈现太阳系终极拯救。' },
  { time: '2026-07-22', title: '用户反馈系统上线', desc: '影迷可通过新系统提交片源推荐和错误反馈，共建更全电影大全。' },
];

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Asian%20person%20portrait%20with%20warm%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot%20style&width=80&height=80&seq=avatar-1&orientation=squarish',
    name: '星际影迷阿飞',
    time: '2小时前',
    content: '琪琪影院真的太牛了！《星际穿越》4K蓝光版画质炸裂，一点缓冲都没有，比我在其他平台看的清晰太多了。科幻电影爱好者必须收藏！',
    likes: 1283,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20woman%20portrait%20with%20gentle%20expression%2C%20simple%20light%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot%20style&width=80&height=80&seq=avatar-2&orientation=squarish',
    name: '追剧小丸子',
    time: '5小时前',
    content: '片库更新速度真的快，《碟中谍8》才下院线没几天这里就有了蓝光版。动作电影这块琪琪影院绝对是全网最快最全的。',
    likes: 967,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20middle-aged%20man%20portrait%20with%20friendly%20smile%2C%20simple%20warm%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot%20style&width=80&height=80&seq=avatar-3&orientation=squarish',
    name: '电影老司机',
    time: '8小时前',
    content: '用了三年琪琪影院了，从最初的几百部电影到现在两万多部，看着它一步步成长为真正的电影大全。画质好、不卡顿、没广告，良心平台。',
    likes: 2145,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20man%20portrait%20with%20cool%20expression%2C%20simple%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20professional%20headshot%20style&width=80&height=80&seq=avatar-4&orientation=squarish',
    name: '诺兰铁粉小王',
    time: '12小时前',
    content: '诺兰导演合集居然有12部全收录！从《记忆碎片》到《奥本海默》，每一部都是蓝光画质，简直是我这种影迷的天堂。强烈推荐！',
    likes: 1865,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20woman%20portrait%20with%20bright%20smile%2C%20simple%20light%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot%20style&width=80&height=80&seq=avatar-5&orientation=squarish',
    name: '流浪的蓝光控',
    time: '1天前',
    content: '《流浪地球3》蓝光版上线第一时间就来看了，特效细节在4K画质下真的太震撼了。感谢琪琪影院给科幻迷这么好的观影体验！',
    likes: 3210,
  },
];

export const rankingItems = [
  { rank: 1, title: '星际穿越', category: '科幻', heat: '9.8', trend: 'up' },
  { rank: 2, title: '碟中谍8：最终清算', category: '动作', heat: '9.6', trend: 'up' },
  { rank: 3, title: '流浪地球3', category: '科幻', heat: '9.5', trend: 'up' },
  { rank: 4, title: '奥本海默', category: '剧情', heat: '9.3', trend: 'stable' },
  { rank: 5, title: '沙丘2', category: '科幻', heat: '9.2', trend: 'up' },
  { rank: 6, title: '疾速追杀4', category: '动作', heat: '9.0', trend: 'stable' },
  { rank: 7, title: '盗梦空间', category: '科幻', heat: '8.9', trend: 'up' },
];

export const cardItems = [
  {
    title: '赛博朋克：边缘行者',
    category: '动画',
    desc: 'Netflix现象级动画，赛博朋克世界观下的残酷青春物语，视觉风格炸裂。',
    image: 'https://readdy.ai/api/search-image?query=A%20cyberpunk%20anime%20style%20cityscape%20with%20neon%20lights%20and%20flying%20vehicles%2C%20futuristic%20dystopian%20aesthetic%2C%20warm%20neon%20pink%20and%20gold%20highlights%20against%20dark%20city%2C%20cinematic%20composition&width=600&height=400&seq=card-1&orientation=landscape',
  },
  {
    title: '疯狂的麦克斯：狂暴女神',
    category: '动作',
    desc: '废土世界史诗续作，安雅主演的狂暴女神起源故事，视觉冲击力拉满。',
    image: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20desert%20wasteland%20with%20modified%20vehicles%20kicking%20up%20dust%2C%20warm%20orange%20and%20sand%20tones%2C%20cinematic%20wide%20shot%2C%20intense%20action%20atmosphere%2C%20dramatic%20sky&width=600&height=400&seq=card-2&orientation=landscape',
  },
  {
    title: '蜘蛛侠：纵横宇宙',
    category: '动画',
    desc: '奥斯卡最佳动画续作，突破想象力的视觉风格，每个画面都是一幅艺术品。',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20comic-book%20style%20cityscape%20with%20a%20spider-themed%20hero%20swinging%20between%20buildings%2C%20bold%20colors%2C%20dynamic%20angles%2C%20pop%20art%20aesthetic%2C%20warm%20and%20cool%20tone%20contrast&width=600&height=400&seq=card-3&orientation=landscape',
  },
  {
    title: '哥斯拉大战金刚2',
    category: '科幻',
    desc: '两大巨兽再次对决，IMAX画质下的怪兽史诗，视觉特效全面超越前作。',
    image: 'https://readdy.ai/api/search-image?query=Two%20massive%20monsters%20facing%20off%20in%20a%20destroyed%20city%2C%20epic%20scale%2C%20cinematic%20lighting%20with%20warm%20sunset%20glow%2C%20dust%20and%20debris%2C%20dramatic%20composition%2C%20blockbuster%20movie%20aesthetic&width=600&height=400&seq=card-4&orientation=landscape',
  },
  {
    title: '封神第二部',
    category: '奇幻',
    desc: '中国神话史诗巨制续作，视觉特效全面升级，东方奇幻美学的巅峰呈现。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20battle%20scene%20with%20warriors%20in%20ornate%20armor%2C%20dramatic%20skies%20with%20golden%20light%2C%20epic%20cinematic%20composition%2C%20traditional%20Chinese%20aesthetic%2C%20warm%20and%20rich%20color%20palette&width=600&height=400&seq=card-5&orientation=landscape',
  },
  {
    title: '死侍与金刚狼',
    category: '动作',
    desc: '漫威最不正经的超级英雄组合，R级动作喜剧，打破第四面墙的疯狂冒险。',
    image: 'https://readdy.ai/api/search-image?query=A%20playful%20superhero%20duo%20in%20red%20and%20yellow%20costumes%20posing%20dynamically%20in%20an%20urban%20setting%2C%20cinematic%20lighting%2C%20warm%20and%20vibrant%20colors%2C%20action-comedy%20movie%20aesthetic%2C%20dynamic%20composition&width=600&height=400&seq=card-6&orientation=landscape',
  },
  {
    title: '你想活出怎样的人生',
    category: '动画',
    desc: '宫崎骏退休之作，奥斯卡最佳动画长片，手绘美学的终极浪漫。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20hand-drawn%20animation%20style%20scene%20with%20a%20child%20exploring%20a%20magical%20surreal%20landscape%2C%20Studio%20Ghibli%20aesthetic%2C%20warm%20pastel%20colors%2C%20soft%20lighting%2C%20dreamy%20atmosphere%2C%20pastoral%20and%20fantasy%20elements&width=600&height=400&seq=card-7&orientation=landscape',
  },
];